import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'ui/Icon';

const STATUS = {
  INCOMPLETE: 'incomplete',
  GRADE_PENDING: 'grade_pending',
  COMPLETED: 'completed',
};

const StatusIcon = ({ status, grade }) => {
  if (status === STATUS.COMPLETED) {
    return grade.success ? (
      <Icon name="check_mark" className="c-green" />
    ) : (
      <span className="t-sx--1">
        <Icon name="undo" />
      </span>
    );
  }

  return <Icon name="clock" />;
};

const StatusText = ({ status, grade }) => {
  let text = t('demonstrations.incomplete_status');
  if (status === STATUS.COMPLETED) {
    text = grade.success
      ? t('demonstrations.completed_status')
      : t('demonstrations.failure_status');
  }

  if (status === STATUS.GRADE_PENDING) {
    text = t('demonstrations.grade_pending_status');
  }

  return <span className="fw-b ml-8">{text}</span>;
};

const AttemptStatus = ({ status, grade }) => {
  return (
    <span className="d-f fd-r fz-16 ai-c">
      <StatusIcon status={status} grade={grade} />
      <StatusText status={status} grade={grade} />
    </span>
  );
};

AttemptStatus.propTypes = {
  status: PropTypes.oneOf(Object.values(STATUS)),
  grade: PropTypes.shape({
    success: PropTypes.bool,
  }),
};

export default AttemptStatus;
